import React, { Component, Fragment } from "react";

import Clock from "./Clock";
import GeneroContainer from "./GeneroContainer";
import ModalidadContainer from "./ModalidadContainer";

import { connect } from "react-redux";

import SvgSetter from "./SvgSetter";

import { initMap } from "./Map";

var mapUp, mapDown;

class GenericContainer extends Component {
  setMapa = () => {
    initMap(this.props.idMap + "1", mapUp, this.props.data.mapaAnio, {
      user: { users: { perfil: this.props.perfil } },
    });
    initMap(this.props.idMap + "2", mapDown, this.props.data.mapaSemana, {
      user: { users: { perfil: this.props.perfil } },
    });
  };
  componentDidMount() {
    this.setMapa();
  }
  componentDidUpdate = () => {
    this.setMapa();
  };

  getData = (data) => {
    const dataTal = {
      dataSet: [],
      date: "",
      fenomeno: 0,
      name: "_homicidios",
      source: "DEANT CICRI, GICRI, SECRETARÍA DE SALUD",
      title: "Homicidios",
    };
    if (data === undefined) {
      return dataTal;
    }
    return data;
  };
  render() {
    const top = "#1A171B";
    const button = "#006290";
    const { data } = this.props;
    return (
      <Fragment>
        <div>
          <div className="header-fenomene-type-1">
            <div className={"tittle-fenomeno " + this.props.type.group}>
              <p>{this.props.type.groupName}</p>
            </div>
            <div className={"icon-fenomene " + this.props.type.group}>
              <SvgSetter
                name={"icon-fenom-" + this.props.idMap}
                width={34}
                height={50}
              >
                {this.props.type.icon}
              </SvgSetter>
            </div>
            <div>
              <div
                className={"header-line " + this.props.type.group + "-border"}
              >
                {this.props.type.fen}
              </div>
            </div>
          </div>
          <div className="row-5-elements top-elements">
            <div className="clock-element">
              <Clock
                name={"clock-homi"}
                title={"titulos"}
                data={data.gaugesAnio.dataSet}
                group={this.props.type.group}
              />
            </div>
            {this.props.gender && (
              <div className="type-icon-elemetn">
                <div>Género</div>
                <GeneroContainer
                  data={this.props.data.generoAnio[1]}
                  name={"genero-ano1-" + this.props.idMap}
                  fenom={this.props.data.fenomeno}
                  top={top}
                  button={button}
                  width={30}
                  height={70}
                />
                <GeneroContainer
                  data={this.props.data.generoAnio[0]}
                  name={"genero-ano2-" + this.props.idMap}
                  fenom={this.props.data.fenomeno}
                  top={top}
                  button={button}
                  width={30}
                  height={70}
                />
              </div>
            )}
            {this.props.zone && (
              <div className="type-icon-elemetn">
                <div>Tipo Zona</div>
                <ModalidadContainer
                  data={this.getData(this.props.data.zonaAnio[0])}
                  name="zona-ano1-hr"
                  top={top}
                  button={button}
                  width={84}
                  height={70}
                />
                <ModalidadContainer
                  data={this.getData(this.props.data.zonaAnio[1])}
                  name="zona-ano2-hr"
                  top={top}
                  button={button}
                  width={84}
                  height={70}
                />
              </div>
            )}
            {this.props.mod && (
              <div className="type-icon-elemetn">
                <div>Movil Victimario</div>
                <ModalidadContainer
                  data={this.getData(this.props.data.modalidadAnio[0])}
                  name={"modalidad-ano-" + this.props.idMap}
                  top={top}
                  button={button}
                  width={84}
                  height={70}
                />
              </div>
            )}
            {this.props.med && (
              <div className="type-icon-elemetn">
                <div>Medios Utilizados</div>
                <ModalidadContainer
                  data={this.getData(this.props.data.mediosAnio[0])}
                  name={"medio-ano-" + this.props.idMap}
                  top={top}
                  button={button}
                  width={84}
                  height={70}
                />
              </div>
            )}
            {this.props.jorn && (
              <div className="type-icon-elemetn">
                <div>Jornada</div>
                <ModalidadContainer
                  data={this.getData(this.props.data.jornadaAnio[0])}
                  name="jornada-ano"
                  top={top}
                  button={button}
                  width={84}
                  height={70}
                />
              </div>
            )}
            {this.props.ap && (
              <div className="type-icon-elemetn">
                <div>Actividad Productiva</div>
                <ModalidadContainer
                  data={this.getData(this.props.data.epApAnio[0])}
                  name="act-prod-ano"
                  top={top}
                  button={button}
                  width={84}
                  height={70}
                />
              </div>
            )}
            {this.props.etar && (
              <div className="type-icon-elemetn">
                <div>Grupo Etáreo</div>
                <ModalidadContainer
                  data={this.getData(this.props.data.grupoEtarioAnio[0])}
                  name="getario-ano"
                  top={top}
                  button={button}
                  width={84}
                  height={70}
                />
              </div>
            )}
            <div className="type-map-element">
              <p>Densidad de casos</p>
              <div
                id={this.props.idMap + "1"}
                style={{ height: "200px" }}
              ></div>
            </div>
          </div>
        </div>
        <div className={"center-line " + this.props.type.group}>
          <p>{this.props.midTittle}</p>
        </div>
        <div>
          <div className="row-5-elements buttom-elements">
            <div className="">
              <Clock
                name={"clock-homi-sem"}
                title={"titulos"}
                data={data.gaugesSemana.dataSet}
                group={this.props.type.group}
              />
            </div>
            {data.gaugesSemana.dataSet !== undefined &&
            data.gaugesSemana.dataSet.length === 0 ? (
              <React.Fragment>
                <div className="type-icon-elemetn"></div>
                {this.props.gender && (
                  <div className="type-icon-elemetn">
                    <div>Género</div>
                    <GeneroContainer
                      data={this.props.data.generoSemana[1]}
                      name={"genero-semana1-" + this.props.idMap}
                      fenom={this.props.data.fenomeno}
                      top={top}
                      button={button}
                      width={30}
                      height={70}
                    />
                    <GeneroContainer
                      data={this.props.data.generoSemana[0]}
                      name={"genero-semana2-" + this.props.idMap}
                      fenom={this.props.data.fenomeno}
                      top={top}
                      button={button}
                      width={30}
                      height={70}
                    />
                  </div>
                )}
                {this.props.zone && (
                  <div className="type-icon-elemetn">
                    <div>Tipo Zona</div>
                    <ModalidadContainer
                      data={this.getData(this.props.data.zonaSemana[0])}
                      name="zona-semana1-hr"
                      top={top}
                      button={button}
                      width={84}
                      height={70}
                    />
                    <ModalidadContainer
                      data={this.getData(this.props.data.zonaSemana[1])}
                      name="zona-semana2-hr"
                      top={top}
                      button={button}
                      width={84}
                      height={70}
                    />
                  </div>
                )}
                <div className="type-icon-elemetn"></div>
              </React.Fragment>
            ) : (
              <React.Fragment>
                {this.props.gender && (
                  <div className="type-icon-elemetn">
                    <div>Género</div>
                    <GeneroContainer
                      data={this.props.data.generoSemana[1]}
                      name={"genero-semana1-" + this.props.idMap}
                      fenom={this.props.data.fenomeno}
                      top={top}
                      button={button}
                      width={30}
                      height={70}
                    />
                    <GeneroContainer
                      data={this.props.data.generoSemana[0]}
                      name={"genero-semana2-" + this.props.idMap}
                      fenom={this.props.data.fenomeno}
                      top={top}
                      button={button}
                      width={30}
                      height={70}
                    />
                  </div>
                )}
                {this.props.zone && (
                  <div className="type-icon-elemetn">
                    <div>Tipo Zona</div>
                    <ModalidadContainer
                      data={this.getData(this.props.data.zonaSemana[0])}
                      name="zona-semana1-hr"
                      top={top}
                      button={button}
                      width={84}
                      height={70}
                    />
                    <ModalidadContainer
                      data={this.getData(this.props.data.zonaSemana[1])}
                      name="zona-semana2-hr"
                      top={top}
                      button={button}
                      width={84}
                      height={70}
                    />
                  </div>
                )}
                {this.props.mod && (
                  <div className="type-icon-elemetn">
                    <div>Movil Victimario</div>
                    <ModalidadContainer
                      data={this.getData(this.props.data.modalidadSemana[0])}
                      name={"modalidad-sem-" + this.props.idMap}
                      top={top}
                      button={button}
                      width={84}
                      height={70}
                    />
                  </div>
                )}
                {this.props.med && (
                  <div className="type-icon-elemetn">
                    <div>Medios Utilizados</div>
                    <ModalidadContainer
                      data={this.getData(this.props.data.mediosSemana[0])}
                      name={"medio-semana-" + this.props.idMap}
                      top={top}
                      button={button}
                      width={84}
                      height={70}
                    />
                  </div>
                )}
                {this.props.jorn && (
                  <div className="type-icon-elemetn">
                    <div>Jornada</div>
                    <ModalidadContainer
                      data={this.getData(this.props.data.jornadaSemana[0])}
                      name="jornada-semana-"
                      top={top}
                      button={button}
                      width={84}
                      height={70}
                    />
                  </div>
                )}
                {this.props.ap && (
                  <div className="type-icon-elemetn">
                    <div>Actividad Productiva</div>
                    <ModalidadContainer
                      data={this.getData(this.props.data.epApSemana[0])}
                      name="act-prod-semana"
                      top={top}
                      button={button}
                      width={84}
                      height={70}
                    />
                  </div>
                )}
                {this.props.etar && (
                  <div className="type-icon-elemetn">
                    <div>Grupo Etáreo</div>
                    <ModalidadContainer
                      data={this.getData(this.props.data.grupoEtarioSemana[0])}
                      name="getario-semana"
                      top={top}
                      button={button}
                      width={84}
                      height={70}
                    />
                  </div>
                )}
              </React.Fragment>
            )}
            <div className="type-map-element">
              <p>Densidad de casos</p>
              <div
                id={this.props.idMap + "2"}
                style={{ height: "200px" }}
              ></div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
  };
}

export default connect(mapStateToProps)(GenericContainer);
